const s = require("./api.module.scss");

import { default as React } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { ApplicationState } from "core/app";
import JSONPretty from "react-json-pretty";
import { PageList, FilterField } from "core/pages/pageList";


interface OwnState {
    applicationState: ApplicationState;
    jsonStyle: any;
    selectedEndpoint: PageList;
}

type PageProps = OwnState & WithTranslation;

const Page = ({ t, applicationState, selectedEndpoint, jsonStyle }: PageProps) => {

    return (

        <div>
            {/*<div className="inputlabel">Request headers</div>
            <JSONPretty data={{ Authorization: "Bearer " + (applicationState.userRole === "Guest" ? "***Enter Your Personal Token Here)***" : applicationState.userToken) }} theme={jsonStyle}></JSONPretty>*/}
            <div className="inputlabel">Request parameters</div>
            <JSONPretty data={selectedEndpoint.parameters} theme={jsonStyle}></JSONPretty>
            {selectedEndpoint.filterFields != null && selectedEndpoint.filterFields.length > 0 && <> <div className="inputlabel">Filter</div>
                <JSONPretty data={selectedEndpoint.filterFields.map((f: FilterField) => f.parameter + ": " + f.type.replace("text", "string").replace("multiselect", "string[]"))} theme={jsonStyle}></JSONPretty>
            </>}
        </div >
    );
};


export default withTranslation()(Page);
